import React from 'react';

import './styles/global.css';
import Landing from './pages/landing';

function App() {
  return (
    <Landing />
  );
}

export default App;
